export default __webpack_public_path__ + "static/media/Covidtracker.997a4229.png";